// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "6b0dc5920b6df287509966a9c72142fe" + ".js";
};